// extracted by mini-css-extract-plugin
export default {"missingData":"MissingData_missingData__y9mRa","text":"MissingData_text__kEVJ1","small":"MissingData_small__eROBe"};